<template>
<div>
	<Card :title="title">
        <Form :label-width="120" class="mt15">
			<Row>
				<Col span="12">
					<FormItem label="批单状态：">
						{{ info.statusName }}
					</FormItem>
				</Col>
				<Col span="12">
					<FormItem label="批单号：">
						<span class="lineFeed">{{ info.billNo }}</span>
					</FormItem>
				</Col>
				<Col span="12">
					<FormItem label="保单号：">
						<a :href="'#/my/customizedLineWork/policyDetail/'+(info.policyNo)" target="_blank" rel="opener" class="lineFeed">{{ info.policyNo }}</a>
					</FormItem>
				</Col>
				<Col span="12">
					<FormItem label="批单创建时间：">
						{{ info.createTime }}
					</FormItem>
				</Col>
				<Col span="12">
					<FormItem label="参保公司：">
						{{ info.companyName }}
					</FormItem>
				</Col>
			</Row>
		</Form>
    </Card>
</div>
</template>
<script>
export default {
	props:{
		info:{
			type:Object,
			default(){
				return {}
			}
		},
		title:String,
		type:{
			type:String,
			default(){
				return 'order'
			}
		},
	},
	methods:{
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedLineWork/common/riderBasicInfo.vue